import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Tag } from "primereact/tag";

const guiaMontosData = [
    {
        tipo: 'Administración de Bienes',
        monto: 'Valor comercial o contable de los bienes aportados al patrimonio autónomo.',
        fuente: 'Acta de constitución o último avalúo vigente.',
        ejemplo: 'Bien inmueble avaluado en $250,000 → ingresar $250,000.'
    },
    {
        tipo: 'Administración de Flujos',
        monto: 'Flujo total proyectado a administrar en un año (monto anualizado).',
        fuente: 'Proyección de flujos del contrato o presupuesto anual.',
        ejemplo: 'Recibe $5,000 mensuales → ingresar $60,000 (anualizado), no $5,000.'
    },
    {
        tipo: 'Garantía',
        monto: 'Monto de la obligación garantizada; si el avalúo del bien es mayor, se ingresa el valor del bien.',
        fuente: 'Contrato de crédito/obligación y avalúo del bien en garantía.',
        ejemplo: 'Bien avaluado en $180,000 garantiza obligación de $120,000 → ingresar $180,000.'
    },
    {
        tipo: 'Inmobiliario',
        monto: 'Valor total del proyecto (terreno + construcción, o valor comercial total de las unidades).',
        fuente: 'Presupuesto del proyecto o estudio de factibilidad.',
        ejemplo: 'Proyecto de $3,200,000 → ingresar $3,200,000, aunque la promesa de compraventa puntual sea de $65,000.'
    }
];

const tipoConfig = {
    'Administración de Bienes': { severity: 'info', icon: 'pi pi-box' },
    'Administración de Flujos': { severity: 'success', icon: 'pi pi-chart-line' },
    'Garantía': { severity: 'warning', icon: 'pi pi-shield' },
    'Inmobiliario': { severity: 'help', icon: 'pi pi-home' }
};

const tipoTemplate = (rowData) => {
    const config = tipoConfig[rowData.tipo] || { severity: 'info', icon: 'pi pi-info-circle' };
    return (
        <Tag value={rowData.tipo} severity={config.severity} icon={config.icon} className="text-sm px-2 py-1 white-space-nowrap" />
    );
};

const fuenteTemplate = (rowData) => (
    <div className="flex align-items-start gap-2 text-700 text-sm">
        <i className="pi pi-file-edit text-primary mt-1 text-base"></i>
        <span>{rowData.fuente}</span>
    </div>
);

const ejemploTemplate = (rowData) => (
    <div className="surface-100 p-2 border-round border-left-3 border-primary text-700 font-italic text-sm line-height-3">
        {rowData.ejemplo}
    </div>
);

export class InfoLaboralClientePj {

    optionLabel = 'nombre';

    constructor(config = {}) {
        this.model = {
            id: { value: null, export: false, header: 'Código', },
            // D. INFORMACIÓN LABORAL DEL REPRESENTANTE LEGAL
            tipo_relacion_laboral_rep: { value: null, export: false, header: 'Tipo de relación laboral:', required: 'El tipo de relación laboral es requerido' },
            profesion: { value: '', export: true, header: 'Profesión:', max: 200, },
            actividad_economica_rep: { value: null, export: false, header: 'Actividad Económica:', required: 'La actividad económica es requerida' },
            nombre_empresa_rep: { value: '', export: true, header: 'Nombre de la Empresa:', max: 200, },
            cargo_rep: { value: '', export: true, header: 'Cargo:', max: 200, },
            fecha_inicio_laboral: { value: null, export: false, header: 'Fecha de inicio de actividad:', },
            // Ubicación de la Empresa del Rep. Legal
            pais_empresa: { value: null, export: false, header: 'País de la empresa:', },
            provincia_empresa: { value: null, export: false, header: 'Provincia de la empresa:', },
            ciudad_empresa: { value: null, export: false, header: 'Ciudad de la empresa:', },
            ciudad_empresa_txt: { value: '', export: false, header: 'Ciudad (Extranjero):', max: 200, },
            // Información Financiera del Representante Legal
            ingreso_mensual: { value: 0, export: true, header: 'Ingreso mensual:', required: 'Requerido', min: 0, },
            egreso_mensual: { value: 0, export: true, header: 'Egreso mensual:', required: 'Requerido', min: 0, },
            total_activo_rep: { value: 0, export: true, header: 'Total Activos:', required: 'Requerido', min: 0, },
            total_pasivo_rep: { value: 0, export: true, header: 'Total Pasivos:', required: 'Requerido', min: 0, },
            // Información de la matriz
            tipo_estructura: { value: null, header: 'TIPO / ESTRUCTURA LEGAL', required: 'Campo requerido' },
            tipo_bien: { value: null, header: 'Tipo de servicio / bien', required: 'Tipo de bien es requerido' },
            monto: {
                value: null,
                header: 'Monto',
                required: 'El monto es requerido y debe ser mayor a US$1,000.00',
                min: 1000,
                helpContent: (
                    <div>
                        <div className="font-bold text-800 mb-3 text-lg flex align-items-center gap-2">
                            <i className="pi pi-info-circle text-primary text-xl"></i>
                            <span>Criterios para el ingreso del Monto según Tipo de Fideicomiso</span>
                        </div>

                        <DataTable value={guiaMontosData} size="small" stripedRows showGridlines className="text-sm border-1 surface-border border-round overflow-hidden">
                            <Column header="TIPO DE FIDEICOMISO" body={tipoTemplate} style={{ width: '22%' }} />
                            <Column field="monto" header="¿QUÉ MONTO INGRESAR?" style={{ width: '28%', fontWeight: '500', fontSize: '0.875rem' }} />
                            <Column header="FUENTE DEL DATO" body={fuenteTemplate} style={{ width: '25%' }} />
                            <Column header="EJEMPLO" body={ejemploTemplate} style={{ width: '25%' }} />
                        </DataTable>
                    </div>
                )
            },
            pais_bien: { value: null, header: 'País del bien / servicio', required: 'País del bien es requerido' },
            provincia_bien: { value: null, header: 'Provincia del bien / servicio', required: 'Provincia del bien es requerido' },
            ciudad_bien: { value: null, header: 'Ciudad del bien / servicio', required: 'Ciudad del bien es requerido' },
            canton_bien: {
                value: '', header: 'Ciudad del bien / servicio', required: 'Ciudad del bien es requerido', maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 300, min: 4,
            },
            tipo_transaccion: { value: null, header: 'TIPO DE TRANSACCIÓN / SERVICIO:', required: 'Tipo de transacción es requerido' },
            instrumento: { value: null, header: 'INSTRUMENTO MONETARIO CON QUE PAGA EL CLIENTE:', required: 'Instrumento de pago es requerido' },
            canal: { value: null, header: 'Canal de servicio', required: 'Canal de servicio es requerido' },
            pais_canal: { value: null, header: 'País canal del servicio', required: 'País canal del servicio es requerido' },
            provincia_canal: { value: null, header: 'Provincia canal del servicio', required: 'Provincia canal del servicio es requerido' },
            ciudad_canal: { value: null, header: 'Ciudad canal del servicio', required: 'Ciudad canal del servicio es requerido' },
            canton_canal: {
                value: '', header: 'Ciudad canal del servicio', required: 'Ciudad canal del servicio es requerido', maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 300, min: 4,
            },
            pais_fondo: { value: null, header: 'PAÍS DE PROCEDENCIA DE LOS FONDOS DEL CLIENTE', required: 'País fondo es requerido' },
        };
    }
}